import React from 'react';


const Contact = () => {
  return (
    <>
      <div className="contactportion">
        <a href="https://github.com/gautamop01" target='_blank' rel="noopener noreferrer">GITHUB</a>
        <a href="mailto:gautam.kumar.21031@iitgoa.ac.in" target='_blank' rel="noopener noreferrer">GMAIL</a>
        <a href="https://www.linkedin.com/in/gautam-kumar-mahar-35b103234/" target='_blank' rel="noopener noreferrer">LINKEDIN</a>
      </div>
    </>
  );
  
}

export default Contact;

// mailto:gautam.kumar.21031@iitgoa.ac.in